import { iCustomerPaymentMethod } from "@sdk/customer-payment-methods/customer-payment-method-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectCustomerPaymentMethodQueryMap,
  selectEntityMap: selectCustomerPaymentMethodsMap,
  selectQueryMapAll: selectCustomerPaymentMethodsMapAll,
  selectQueryAllList: selectCustomerPaymentMethodsAllList,
  selectAllEntities: selectAllCustomerPaymentMethods,
  selectAllEntitiesQuery: selectAllCustomerPaymentMethodsQuery,
  selectEntityById: selectCustomerPaymentMethodById,
  selectEntityQuery: selectCustomerPaymentMethodQuery,
  selectEntityQueryList: selectCustomerPaymentMethodQueryList,
} = CreateSelectorForEntities<iStore, iCustomerPaymentMethod>({
  sliceName: "customerPaymentMethods",
});
